import { Select } from 'antd';
const DropDownList = (props) => {
	const this_OnChange = (value) => {
		if (props.onChange) { props.onChange(value); }
	};

	const bLoading = props.bLoading ?? false;
	const aMapOptions = props.aOptions.map((oItem, iIndex) => (
		{ value: oItem[props.cFieldValue], label: oItem[props.cFieldText] }
	));

	return (
		<Select defaultValue={props.oValue} loading={bLoading} options={aMapOptions} onChange={this_OnChange} />
	);
}
export default DropDownList;